import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  coMembershipBanner: {
    id: 'product-card.card.co-membership.banner',
    defaultMessage: 'CLASSPASS + {coMembershipType}',
  },
  coMembershipDetails: {
    id: 'product-card.card.co-membership.details',
    defaultMessage: 'All-Access {coMembershipType} Gym Membership',
  },
  ctaSelect: {
    id: 'product-card.card.cta.select',
    defaultMessage: 'Select',
  },
  disclaimerAutoRenewal: {
    id: 'product-card.disclaimer.autoRenewal',
    defaultMessage:
      'After your trial, you’ll auto-enroll in our {price}/month plan. You can change or cancel any time during your trial.',
  },
  disclaimerAutoRenewalDefault: {
    id: 'product-card.disclaimer.autoRenewal-default',
    defaultMessage:
      'After your trial, you’ll auto-enroll in the plan of your choosing. You can change or cancel any time during your trial.',
  },
  firstMonthOfferNote: {
    id: 'product-card.card.first-month-offer-note',
    defaultMessage: '~~{recurringPrice}~~ first month',
  },
  planDetails: {
    id: 'product-card.card.plan-details',
    defaultMessage:
      'Includes __{creditsPerCycle, number}&nbsp;credits__ to book __{minClassEstimate, number}&nbsp;-&nbsp;{maxClassEstimate, number}&nbsp;classes__',
  },
});
